// Match the backend approval cutoff: a date-only deadline includes its full UTC day.
export function vacancyClosingDeadline(value) {
  if (!value) return null;
  const text = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    const date = new Date(text + "T00:00:00Z");
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== text) return new Date(NaN);
    date.setUTCDate(date.getUTCDate() + 1);
    return date;
  }
  // The backend treats timestamps without an explicit offset as UTC.
  const utcText = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(text) ? text + "Z" : text;
  return new Date(utcText);
}
